import React, {Component} from "react"
import AccountLogoUploadImage from "./AccountLogoUploadImage"

class EnterprisePageHeader extends Component {
  render() {
    return (
      <div className="row wrapper border-bottom white-bg page-heading">
        <div className="col-xs-6">
          <h2>{this.props.title}</h2>
          <p>{this.props.subtitle}</p>
        </div>
        <div className="col-xs-6">
          <AccountLogoUploadImage className="pull-right"/>
        </div>
      </div>

    )
  }
}

export default EnterprisePageHeader



// WEBPACK FOOTER //
// ./src/routes/enterprise/components/EnterprisePageHeader.js